/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import { formatRoute } from 'react-router-named-routes';
import { withTranslation } from 'react-i18next';
// material-ui icons
import Edit from '@material-ui/icons/Edit';
import Lock from '@material-ui/icons/Lock';
import Build from '@material-ui/icons/Build';
import Erase from '@material-ui/icons/Delete';
import Refresh from '@material-ui/icons/Refresh';
import LockOpen from '@material-ui/icons/LockOpen';
import Extension from '@material-ui/icons/Extension';
import CardTravel from '@material-ui/icons/CardTravel';
import FlightLand from '@material-ui/icons/FlightLand';
import Fingerprint from '@material-ui/icons/Fingerprint';
import BrightnessAuto from '@material-ui/icons/BrightnessAuto';
// @material-ui/core components
import userProfileStyles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles';
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import Card from 'components/UI/Card/Card';
import GridItem from 'components/UI/Grid/GridItem';
import Timeline from 'components/UI/Timeline/Timeline';
import Button from 'components/UI/CustomButtons/Button';
import Accordion from 'components/UI/Accordion/Accordion';
import GridContainer from 'components/UI/Grid/GridContainer';
import CustomDropdown from 'components/UI/CustomDropdown/CustomDropdown';
import CardBody from 'components/UI/Card/CardBody';
// our components
import { USER } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import ModalConfirmation from 'components/common/ModalConfirmation';
import WithPermission from 'components/User/WithPermission';
import UserInfo from 'components/User/Info';
import AuthContext from 'helpers/authContext';
// global variables
import { userRanks, userKinds } from 'config';
import { LoadingAnimation } from 'components/common/Loading';
import Zoom from '@material-ui/core/Zoom';
import Tooltip from '@material-ui/core/Tooltip';

const logs = [
  {
    // First story
    badgeColor: 'danger',
    badgeIcon: CardTravel,
    title: 'Some Title',
    titleColor: 'danger',
    body: (
      <p>
        Wifey made the best Fathers Day meal ever. So thankful so happy so
        blessed. Thank you for making my family We just had fun with the
        “future” theme !!! It was a fun night all together ... The always rude
        Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in
        downtown.
      </p>
    ),
    footerTitle: '11 hours ago via Twitter',
  },
  {
    // Second story
    badgeColor: 'success',
    badgeIcon: Extension,
    title: 'Another One',
    titleColor: 'success',
    body: (
      <p>
        Thank God for the support of my wife and real friends. I also wanted to
        point out that it’s the first album to go number 1 off of streaming!!! I
        love you Ellen and also my number one design rule of anything I do from
        shoes to music to homes is that Kim has to like it....
      </p>
    ),
  },
  {
    // Third story
    badgeColor: 'info',
    badgeIcon: Fingerprint,
    title: 'Another Title',
    titleColor: 'info',
    body: (
      <div>
        <p>
          Called I Miss the Old Kanye That’s all it was Kanye And I love you
          like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown
          LA 11:10PM
        </p>
        <p>
          What if Kanye made a song about Kanye Royère doesnt make a Polar bear
          bed but the Polar bear couch is my favorite piece of furniture we own
          It wasn’t any Kanyes Set on his goals Kanye
        </p>
      </div>
    ),
    footer: (
      <CustomDropdown
        buttonIcon={Build}
        buttonProps={{
          round: true,
          style: { marginBottom: '0' },
          color: 'info',
        }}
        dropdownList={[
          'Action',
          'Another action',
          'Something else here',
          { divider: true },
          'Separated link',
        ]}
      />
    ),
  },
  {
    // Fourth story
    badgeColor: 'warning',
    badgeIcon: FlightLand,
    title: 'Another One',
    titleColor: 'warning',
    body: (
      <p>
        Tune into Big Boys 92.3 Im about to play the first single from Cruel
        Winter also to Kim’s hair and makeup Lorraine jewelry and the whole
        style squad at Balmain and the Yeezy team. Thank you Anna for the invite
        thank you to the whole Vogue team
      </p>
    ),
  },
];

/**
 * @class
 * @extends React.Component
 */
class UserDetails extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
    };
  }

  /**
   * @description
   * Redirect to user/update route.
   */
  handleUserUpdate = () => {
    const { data } = this.props;
    const history = this.context;
    history.push(formatRoute(USER.UPDATE, { id: data.adminUser.id }));
  };

  /**
   * @description
   * Redirect to permissions/update route.
   */
  handlePermissionsUpdate = () => {
    const { data } = this.props;
    const history = this.context;
    history.push(formatRoute(USER.PERMISSION, { id: data.adminUser.id }));
  };

  /**
   * @description
   * Switch menu tabs.
   *
   * @param {string} tab - Tab to switch.
   */
  handleTab = tab => {
    const { data } = this.props;
    const history = this.context;
    history.push(
      formatRoute(`${USER.DETAILS}#${tab}`, { id: data.adminUser.id }),
    );
  };

  /**
   * @description
   * Open destroying modal.
   */
  handleOpenModal = () => {
    this.setState({ modalIsOpen: true });
  };

  /**
   * @description
   * Callback to close destroying modal if user close it manually.
   */
  handleCloseModal = () => {
    this.setState({ modalIsOpen: false });
  };

  /**
   * @description
   * Confirm destroying callback to delete user.
   */
  handleSubmit = () => {
    const { userDelete, data } = this.props;

    userDelete([data.adminUser.id]);

    this.setState({
      modalIsOpen: false,
    });
  };

  /**
   * @description
   * Handle block or unBlock action.
   */
  handleAction = () => {
    const { userBlock, userUnBlock, data } = this.props;
    if (data.adminUser.isActive) {
      userBlock([data.adminUser.id]);
    } else {
      userUnBlock([data.adminUser.id]);
    }
  };

  /**
   * @description
   * Render permissions and permissionsGroups items to collapse.
   */
  renderPermissions = () => {
    const { data, t } = this.props;
    const collapses = [];
    if (data.adminUser.permissions && data.adminUser.permissions.length !== 0) {
      collapses.push({
        title: t('user.details.others'),
        content: (
          <span>
            {data.adminUser.permissions.map(edge => (
              <p key={edge.id}>{edge.name}</p>
            ))}
          </span>
        ),
      });
    }
    if (
      data.adminUser.permissionsGroups &&
      data.adminUser.permissionsGroups.length !== 0
    ) {
      data.adminUser.permissionsGroups.map(edge =>
        collapses.push({
          title: edge.name,
          content: (
            <span>
              {edge.permissions.length !== 0 &&
                edge.permissions.map(permissionEdge => (
                  <p key={permissionEdge.id}>{permissionEdge.name}</p>
                ))}
            </span>
          ),
        }),
      );
    }
    return collapses;
  };

  /**
   * @description
   * Map userType to specific strings.
   *
   * @param {string} userType - User type.
   * @param {string} action - Action.
   * @returns {string} Mapped user types.
   */
  handleMapPermissions = (userType, action) => {
    if (userType === userKinds.USER_AGENCY) {
      return [`${action}_useragency`, `${action}_ownership_useragency`];
    }
    if (userType === userKinds.AGENCY) {
      return [`${action}_agency`];
    }
    if (userType === userKinds.USER) {
      return [`${action}_user`];
    }
    return [];
  };

  /**
   * @description
   * Render User Details component.
   * @returns {*} - No returns a value.
   */
  render() {
    const { modalIsOpen } = this.state;
    const {
      classes,
      data,
      userActionLoading,
      t,
      convertUserToAgency,
      refresh,
    } = this.props;
    const history = this.context;
    const hashString = history.location.hash;
    const collapses = this.renderPermissions();
    return (
      <React.Fragment>
        <AuthContext.Consumer>
          {({ userType, allPermissions, id }) => {
            const hasChangeUserAgencyOwnership =
              allPermissions.filter(
                permission =>
                  permission.codename === 'change_ownership_useragency',
              ).length === 1;
            const hasChangeUserAgencyGeneral =
              allPermissions.filter(
                permission => permission.codename === 'change_useragency',
              ).length === 0;
            return (
              <GridContainer className={classes.container}>
                <GridItem xs={12} sm={5} md={4}>
                  <GridContainer justify="flex-end" alignItems="center">
                    <GridItem>
                      <Button
                        color="primary"
                        simple
                        className={classes.showFilters}
                        onClick={() => refresh()}
                        id="refresh"
                        key="refresh"
                      >
                        <Refresh />
                        {t('common.refresh')}
                      </Button>
                    </GridItem>
                  </GridContainer>
                  <Card className={classes.userActions}>
                    {userActionLoading && (
                      <div className={classes.actionsLoader}>
                        <LoadingAnimation />
                      </div>
                    )}
                    <div className={classes.actions}>
                      <WithPermission
                        alt={
                          id === data.adminUser.id && (
                            <Tooltip
                              placement="top"
                              TransitionComponent={Zoom}
                              title={
                                <React.Fragment>
                                  {t('common.pass.change')}
                                  <span className={classes.arrow} />
                                </React.Fragment>
                              }
                              classes={{
                                tooltip: classes.bootstrapTooltip,
                                tooltipPlacementTop:
                                  classes.bootstrapPlacementTop,
                              }}
                            >
                              <Button
                                data-cy="userUpdateAction"
                                color="success"
                                id="user-update"
                                onClick={() =>
                                  history.push(USER.CHANGE_PASSWORD)
                                }
                              >
                                {t('common.pass.change')}
                              </Button>
                            </Tooltip>
                          )
                        }
                        allowPermissions={this.handleMapPermissions(
                          data.adminUser.userType,
                          'change',
                        )}
                      >
                        {hasChangeUserAgencyOwnership &&
                        !hasChangeUserAgencyGeneral ? (
                          userType === userKinds.AGENCY && (
                            <Tooltip
                              placement="top"
                              TransitionComponent={Zoom}
                              title={
                                <React.Fragment>
                                  {t('common.edit')}
                                  <span className={classes.arrow} />
                                </React.Fragment>
                              }
                              classes={{
                                tooltip: classes.bootstrapTooltip,
                                tooltipPlacementTop:
                                  classes.bootstrapPlacementTop,
                              }}
                            >
                              <Button
                                data-cy="userUpdateAction"
                                color="primary"
                                id="user-update"
                                onClick={this.handleUserUpdate}
                              >
                                {t('common.edit')}
                              </Button>
                            </Tooltip>
                          )
                        ) : (
                          <Tooltip
                            placement="top"
                            TransitionComponent={Zoom}
                            title={
                              <React.Fragment>
                                {t('common.edit')}
                                <span className={classes.arrow} />
                              </React.Fragment>
                            }
                            classes={{
                              tooltip: classes.bootstrapTooltip,
                              tooltipPlacementTop:
                                classes.bootstrapPlacementTop,
                            }}
                          >
                            <Button
                              data-cy="userUpdateAction"
                              color="primary"
                              id="user-update"
                              onClick={this.handleUserUpdate}
                            >
                              {t('common.edit')}
                            </Button>
                          </Tooltip>
                        )}
                        <Tooltip
                          placement="top"
                          TransitionComponent={Zoom}
                          title={
                            <React.Fragment>
                              {data && data.adminUser.isActive
                                ? t('user.list.tooltips.block')
                                : t('user.list.tooltips.unblock')}
                              <span className={classes.arrow} />
                            </React.Fragment>
                          }
                          classes={{
                            tooltip: classes.bootstrapTooltip,
                            tooltipPlacementTop: classes.bootstrapPlacementTop,
                          }}
                        >
                          <Button
                            simple={data && data.adminUser.isActive}
                            color={
                              data && data.adminUser.isActive
                                ? 'primary'
                                : 'success'
                            }
                            id="user-block"
                            justIcon
                            onClick={() => this.handleAction()}
                          >
                            {data && data.adminUser.isActive ? (
                              <Lock />
                            ) : (
                              <LockOpen />
                            )}
                          </Button>
                        </Tooltip>
                      </WithPermission>
                      <WithPermission
                        allowPermissions={this.handleMapPermissions(
                          data.adminUser.userType,
                          'delete',
                        )}
                      >
                        <Tooltip
                          placement="top"
                          TransitionComponent={Zoom}
                          title={
                            <React.Fragment>
                              {t('common.erase')}
                              <span className={classes.arrow} />
                            </React.Fragment>
                          }
                          classes={{
                            tooltip: classes.bootstrapTooltip,
                            tooltipPlacementTop: classes.bootstrapPlacementTop,
                          }}
                        >
                          <Button
                            data-cy="userDeleteAction"
                            simple
                            color="danger"
                            id="user-delete"
                            justIcon
                            onClick={() => this.handleOpenModal()}
                          >
                            <Erase />
                          </Button>
                        </Tooltip>
                      </WithPermission>
                      {data.adminUser.userType === userKinds.USER && (
                        <WithPermission allowPermissions={['add_agency']}>
                          <Tooltip
                            placement="top"
                            TransitionComponent={Zoom}
                            title={
                              <React.Fragment>
                                {t('common.convert_to_agency')}
                                <span className={classes.arrow} />
                              </React.Fragment>
                            }
                            classes={{
                              tooltip: classes.bootstrapTooltip,
                              tooltipPlacementTop:
                                classes.bootstrapPlacementTop,
                            }}
                          >
                            <Button
                              data-cy="userConvertToAgencyAction"
                              color="success"
                              simple
                              justIcon
                              id="user-convert-to-agency"
                              onClick={() =>
                                convertUserToAgency(data.adminUser.id)
                              }
                            >
                              <BrightnessAuto />
                            </Button>
                          </Tooltip>
                        </WithPermission>
                      )}
                    </div>
                  </Card>
                  {data && (
                    <UserInfo id={data.adminUser.id} data={data.adminUser} />
                  )}
                </GridItem>

                <ModalConfirmation
                  show={modalIsOpen}
                  confirm={() => this.handleSubmit()}
                  cancel={() => this.handleCloseModal()}
                  title={<span>{t('user.details.modal.question')}</span>}
                  description={data && data.adminUser.fullname}
                  confirmLabel={t('user.details.modal.ok')}
                />

                <GridItem xs={12} sm={7} md={8}>
                  <GridContainer>
                    <GridItem xs={12}>
                      {data.adminUser.rank === userRanks.STAFF ? (
                        <WithPermission
                          allowPermissions={['change_permission']}
                        >
                          <div>
                            <Button
                              data-cy="userLogsTab"
                              color="primary"
                              simple={hashString === '#permissions'}
                              round
                              id="logs-tab"
                              className={classes.logsBtn}
                              onClick={() => this.handleTab('logs')}
                            >
                              <span>{t('user.details.log_break')}</span>
                              {t('user.details.log')}
                            </Button>

                            <Button
                              data-cy="userPermissionGroupsTab"
                              color="primary"
                              simple={hashString === '#logs'}
                              round
                              id="permissions-tab"
                              onClick={() => this.handleTab('permissions')}
                            >
                              {t('user.details.permissions')}
                            </Button>
                          </div>
                        </WithPermission>
                      ) : (
                        <h3 className={classes.logsBtn}>
                          <span>Últimas</span> acciones
                        </h3>
                      )}
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    {hashString === '#logs' ? (
                      <GridItem>
                        <GridContainer justify="center" alignItems="center">
                          <GridItem data-cy="userLogs" xs={12}>
                            <Timeline stories={logs} />
                          </GridItem>
                          <GridItem xs={12}>
                            <Button color="info">
                              {t('user.details.more')}
                            </Button>
                          </GridItem>
                        </GridContainer>
                      </GridItem>
                    ) : (
                      <GridItem xs={12}>
                        <Card>
                          <CardBody data-cy="userPermissionGroups">
                            <GridContainer justify="flex-end">
                              <GridItem>
                                <WithPermission
                                  allowPermissions={['change_permission']}
                                >
                                  <WithPermission
                                    allowPermissions={['list_group']}
                                  >
                                    <Button
                                      simple
                                      color="primary"
                                      id="permissions-update"
                                      onClick={this.handlePermissionsUpdate}
                                    >
                                      <Edit />
                                      {t('user.details.edit_perm')}
                                    </Button>
                                  </WithPermission>
                                </WithPermission>
                              </GridItem>
                            </GridContainer>

                            {collapses.length > 0 ? (
                              <Accordion active={0} collapses={collapses} />
                            ) : (
                              <p>{t('common.empty_list')}</p>
                            )}
                          </CardBody>
                        </Card>
                      </GridItem>
                    )}
                  </GridContainer>
                </GridItem>
              </GridContainer>
            );
          }}
        </AuthContext.Consumer>
      </React.Fragment>
    );
  }
}

/**
 * UserDetails PropTypes
 * @param classes - prop styles received from withStyles
 * @param data - prop user query's results
 * @param t - prop from HOC with string translations
 * @callback userDelete - callback to remove a user
 * @callback userBlock - callback to block a user
 * @callback userUnBlock - callback to unBlock a user
 * @callback convertUserToAgency - callback to convert a user to agency
 * @callback userActionLoading - boolean to load loading when user tap on action
 * @callback refresh - callback to refresh page
 */

UserDetails.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.shape({}).isRequired,
  userUnBlock: PropTypes.func.isRequired,
  userBlock: PropTypes.func.isRequired,
  userDelete: PropTypes.func.isRequired,
  convertUserToAgency: PropTypes.func.isRequired,
  userActionLoading: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
};

// to fix: The withStyles HOC set contextTypes to a children component
// and it have problem with contextType assigned to PermissionList component
// This is a small hack, with intermediary Component to resolved it temporally
const UserReadWrapper = props => <UserDetails {...props} />;

export default withTranslation()(
  withStyles(userProfileStyles)(UserReadWrapper),
);
